import { Search, Moon, Sun } from "lucide-react";
import { useAuth } from "@/contexts/auth-context";
import { ScopeSwitcher } from "./scope-switcher";
import { useEffect, useState } from "react";

export function AppHeader() {
  const { user } = useAuth();
  const [dark, setDark] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("nexus:theme");
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    const isDark = stored === "dark" || (!stored && prefersDark);
    setDark(isDark);
    document.documentElement.classList.toggle("dark", isDark);
  }, []);

  function toggleTheme() {
    const next = !dark;
    setDark(next);
    document.documentElement.classList.toggle("dark", next);
    localStorage.setItem("nexus:theme", next ? "dark" : "light");
  }

  return (
    <header
      role="banner"
      className="flex h-16 items-center justify-between border-b border-border-1 bg-surface-1 px-4 gap-4"
    >
      {/* Left: Scope switcher */}
      <ScopeSwitcher />

      {/* Center: Search */}
      <button
        className="flex items-center gap-2 rounded-[var(--radius-sm)] border border-border-1 bg-surface-2 px-3 py-1.5 text-sm text-text-3 hover:bg-overlay-hover transition-colors focus-ring max-w-[320px] flex-1"
        style={{ transitionDuration: "var(--transition-duration-fast)" }}
        aria-label="Open search (Cmd+K)"
      >
        <Search className="w-4 h-4" strokeWidth={1.75} aria-hidden="true" />
        <span className="flex-1 text-left truncate">Search...</span>
        <kbd className="hidden sm:inline text-xs text-text-3 bg-bg px-1.5 py-0.5 rounded border border-border-1">
          ⌘K
        </kbd>
      </button>

      {/* Right: Theme toggle + User */}
      <div className="flex items-center gap-2">
        <button
          onClick={toggleTheme}
          className="flex items-center justify-center w-9 h-9 rounded-[var(--radius-sm)] text-text-2 hover:bg-overlay-hover transition-colors focus-ring"
          style={{ transitionDuration: "var(--transition-duration-fast)" }}
          aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
        >
          {dark ? (
            <Sun className="w-[18px] h-[18px]" strokeWidth={1.75} />
          ) : (
            <Moon className="w-[18px] h-[18px]" strokeWidth={1.75} />
          )}
        </button>

        {/* User avatar */}
        <div
          className="flex items-center justify-center w-9 h-9 rounded-full bg-primary text-white text-sm font-medium"
          title={user?.email || "User"}
        >
          {user?.name?.[0]?.toUpperCase() || user?.email?.[0]?.toUpperCase() || "?"}
        </div>
      </div>
    </header>
  );
}
